import { api } from '@/api/api';
const EVENT_NAME = 'miniapp';
const OPEN_EVENT_NAME = 'open';
const CLOSE_EVENT_NAME = 'close';
const DISMISS_EVENT_NAME = 'dismiss';
export class MiniApp {
    constructor() {
        this.eventApi = api.getEventApi();
        this._onClose = null;
        this._context = null;
        this.addMiniAppListener();
    }
    handleCloseMiniApp(payload) {
        if (this._onClose) {
            this._onClose({ payload });
            this._onClose = null;
            this._context = null;
        }
    }
    addMiniAppListener() {
        const closeEventId = this.eventApi.registerSysEventObserver(EVENT_NAME, {
            func: (ev) => {
                const evtName = ev.eventStrData || null;
                if (evtName !== CLOSE_EVENT_NAME) {
                    return;
                }
                this.handleCloseMiniApp(null);
            },
        });
        return () => {
            this.eventApi.unregisterSysEventObserver(EVENT_NAME, closeEventId);
        };
    }
    openMiniApp(prop) {
        const { url, windowSize, payload, title, onClose } = prop;
        if (onClose) {
            this._onClose = onClose;
        }
        if (payload) {
            this._context = payload;
        }
        this.eventApi.sendSysEvent({
            eventName: EVENT_NAME,
            eventStrData: OPEN_EVENT_NAME,
            eventData: {
                url,
                windowSize,
                title,
            },
        });
    }
    dismissFromMiniApp(result) {
        const payload = (result === null || result === void 0 ? void 0 : result.payload) || null;
        this.handleCloseMiniApp(payload);
        this.eventApi.sendSysEvent({
            eventName: EVENT_NAME,
            eventStrData: DISMISS_EVENT_NAME,
            eventData: {
                payload,
            },
        });
    }
    getMiniAppContext() {
        return this._context || null;
    }
}
export const singletonMiniApp = new MiniApp();
